$(document).ready(function(){
  function setlocalHidepopup(){
    localStorage.setItem('HideKlaviyo', "Yes");
}

setTimeout(function(){
    var gethidepopup = localStorage.getItem('HideKlaviyo');

    // Proper condition check
    if(gethidepopup !== 'Yes'){  
       $('.custom_klaviyo_popup_main_outer').fadeIn();
       $('body').addClass('scroll_stop');
    }
}, 5000);

  $(".custom_klaviyo_popup_main .coupon_box .copy_coupon").click(function () {
        var couponText = "SUBSCRIBE20OFF"; // Text to copy

        var $tempInput = $("<input>");
        $("body").append($tempInput);
        $tempInput.val(couponText).select();
        document.execCommand("copy");
        $tempInput.remove();

        // alert("Coupon copied: " + couponText);
       $('.custom_klaviyo_popup_main .success_copied').fadeIn();
       $('.custom_klaviyo_popup_inner .coupon_box').addClass('add_margin');
       setTimeout(function(){
         $('.custom_klaviyo_popup_main .success_copied').fadeOut();
         $('.custom_klaviyo_popup_inner .coupon_box').removeClass('add_margin');
       },3000)
    });
  $('.custom_klaviyo_popup_main span.close_pop, .klaviyo_submit_btn_box span.no_saving').click(function(){
    $('.custom_klaviyo_popup_main').fadeOut();
    $('.custom_klaviyo_popup_main_outer').fadeOut();
    $('body').removeClass('scroll_stop');
    setlocalHidepopup();
  });
   $(document).mouseup(function(e) {
      if (!$(".custom_klaviyo_popup_inner").is(e.target) && $(".custom_klaviyo_popup_inner").has(e.target).length === 0) {
          $('.custom_klaviyo_popup_main').fadeOut();
          $('.custom_klaviyo_popup_main_outer').fadeOut();
          $('body').removeClass('scroll_stop');
          setlocalHidepopup();
      }
  });
  $('.klaviyo_phone_number_box .country_flag').click(function(){
    $('.klaviyo_phone_number_box .country_code_list').fadeToggle();
  });
  $('.klaviyo_phone_number_box .country_code_list li').click(function(){
        let imagepath = $(this).attr('imgpath');
        $('.klaviyo_phone_number_box .country_flag .flag_box img').attr('src', imagepath);
        $(this).parent().fadeOut();
    });
  $(document).click(function(event) {
    if (!$(event.target).closest('.klaviyo_phone_number_box .country_code_list li, .klaviyo_phone_number_box .country_flag').length) {
        $('.klaviyo_phone_number_box ul.country_code_list').fadeOut();
    }
  });
  $('.klaviyo_submit_btn_box span.submit_btn').click(function () {
        var email = $('.klaviyo_email').val().trim();
        var emailLength = email.length;
        let phone = $(".klaviyo_phone").val().trim();
        let phoneLength = phone.length;
        
        $('.klaviyo_email').removeClass('error');
        $('.klaviyo_phone_number_box').removeClass('error');
        $('.custom_klaviyo_popup_form_box_1 ').removeClass('error');
        $('.klaviyo_error_message').text('');
    
        if (emailLength === 0) {
            $('.klaviyo_error_message').text('Email is required:');
            $('.klaviyo_email').addClass('error');
             $('.custom_klaviyo_popup_form_box_1 ').addClass('error');
            return; // Stop execution
        } 
        
        if (!validateEmail(email)) {
            $('.klaviyo_error_message').text('Invalid email, enter a correct email address:');
            $('.klaviyo_email').addClass('error');
            $('.custom_klaviyo_popup_form_box_1 ').addClass('error');
            return; // Stop execution
        } 
        
        if (phone !== '' && (!validatePhone(phone) || phoneLength < 10)) {
            $('.klaviyo_error_message').text('Invalid phone number, enter a correct phone number.');
            $('.klaviyo_phone_number_box').addClass('error');
            $('.custom_klaviyo_popup_form_box_1 ').addClass('error');
            return; // Stop execution
        }
    
        // Call the function only when all validations pass
        klaviyoPushEmailPhone();
    });
      function klaviyoPushEmailPhone() {
        let kemail = $('.custom_klaviyo_popup_form_box input.klaviyo_email').val();
        let kPhone = $('.custom_klaviyo_popup_form_box .klaviyo_phone_number_box input').val();
        let formData = {
          "form_type": "customer",
          "contact[email]": kemail,
          "contact[note][Phone number]": kPhone,
          "contact[tags]": "klaviyo_subscribe"
        };  
        $.ajax({
          type: "POST",
          url: "/contact",
          data: $.param(formData), // Convert object to URL-encoded format
          // beforeSend: function () {
          //   $("#newsletter-message").html("<p style='color: blue;'>⏳ Submitting...</p>");
          // },
          success: function (response) {
            // $("#newsletter-message").html("<p style='color: green;'>✅ Subscription successful!</p>");
            // $(".test_email, .test_phone").val(""); // Clear inputs
            $('.custom_klaviyo_popup_form_box_2').fadeIn();
          $('.custom_klaviyo_popup_form_box_1').fadeOut();
          },
          error: function (xhr, status, error) {
            $(".klaviyo_error_message").text( xhr.responseText );
          }
        });
       
    }
    

    // Email validation function
    function validateEmail(email) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    
    // Phone number validation function
    function validatePhone(phone) {
        var phoneRegex = /^[0-9]{10,15}$/;
        return phoneRegex.test(phone);
    }



})